import { createSlice } from "@reduxjs/toolkit";
//
import axios, { API_ENDPOINTS } from "src/utils/axios";
import { mergeObjects } from "src/utils/format-object";

const initialState = {
    isLoading: false,
    error: null,
    //
    labelPrint: {
        option: "ask"
    },
    labelPackingSlip: {
        print_method: "print_separately",
        label_format: "4_6",
        packing_slip_format: "8.5_11",
        label_and_packing_slip_format: "8.5_11",
        packing_slip_note: ""
    },
    insurance: null,
    international: null,
    orderGetRateMode: "SIDE_BAR"
};

const slice = createSlice({
    name: "automation",
    initialState,
    reducers: {
        // START LOADING
        startLoading(state, action) {
            state.isLoading = action.payload;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            //
            state.error = action.payload;
        },

        clearError(state) {
            state.error = null;
        },

        // UPDATE LABEL PRINT SUCCESS
        updateLabelPrintSuccess(state, action) {
            state.isLoading = false;
            //
            state.labelPrint = {
                ...state.labelPrint,
                ...action.payload
            };
        },

        // UPDATE PRINT SUCCESS
        updatePrintSuccess(state, action) {
            state.isLoading = false;
            //
            state.labelPackingSlip = {
                ...state.labelPackingSlip,
                ...action.payload
            };
        },

        // UPDATE INSURANCE SUCCESS
        updateInsuranceSuccess(state, action) {
            state.isLoading = false;
            //
            state.insurance = action.payload;
        },

        // UPDATE INTERNATIONAL SUCCESS
        updateInternationalSuccess(state, action) {
            state.isLoading = false;
            //
            state.international = action.payload;
        },

        // UPDATE ORDER GET RATE MODE SUCCESS
        updateOrderGetRateModeSuccess(state, action) {
            state.isLoading = false;
            //
            state.orderGetRateMode = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const { clearError } = slice.actions;

// ----------------------------------------------------------------------

export function getPrint() {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.startLoading(true));

            const { status, data } = await axios.get(API_ENDPOINTS.automation.getPrinter);

            if (status === 200) {
                dispatch(slice.actions.updatePrintSuccess(data?.data ?? null));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getLabelPrint() {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.startLoading(true));

            const { status, data } = await axios.get(API_ENDPOINTS.automation.getLabelPrint);

            if (status === 200) {
                dispatch(slice.actions.updateLabelPrintSuccess(data?.data ?? null));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function modifyLabelPrint(request) {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.startLoading(true));
            dispatch(slice.actions.updateLabelPrintSuccess(request));

            const { status } = await axios.post(API_ENDPOINTS.automation.saveLabelPrint, request);

            if (status === 200) {
                dispatch(getLabelPrint());
            }

            return status === 200;
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            //
            return false;
        }
    };
}

// ----------------------------------------------------------------------
